import { ProductInfoForTag } from '@gooduncles/gu-app-schema';
import { Switch, notification } from 'antd';
import { FC, useCallback, useState } from 'react';

import { errorObjectToString } from 'src/utils/common';
import { mergeProductGroupForCategory } from 'src/utils/firebase/firebase-short-cut';
import { AuditLogger } from 'src/utils/audit-logger';

const auditLogger = AuditLogger.getInstance();

/**
 * 상품을 미노출 처리합니다.
 */
export const AgCellToggleProductForCategory: FC<{
  context: { category: string };
  data: ProductInfoForTag & { mainTag: string };
  value: boolean;
}> = ({ context, data, value }) => {
  const [loading, setLoading] = useState(false);

  const handleSwitchChange = useCallback(
    async (value: boolean) => {
      setLoading(true);
      try {
        await mergeProductGroupForCategory(
          context.category,
          {
            mainTags: {
              [data?.mainTag]: {
                productsForMainTag: {
                  [data?.productId]: {
                    hide: value,
                  },
                },
              },
            },
          },
          { audit: { suppress: true } },
        );
        auditLogger.log({
          action: 'UPDATE',
          entity: 'storeCategory',
          entityId: `${context.category}/${data?.mainTag}/${data?.productId}`,
          summary: `업종 관리 - ${context.category}/${data?.mainTag}/${data?.productId} ${value ? '미노출' : '노출'} 처리`,
        });
      } catch (error) {
        console.error(error);
        const description = errorObjectToString(error);
        auditLogger.log({
          action: 'UPDATE',
          entity: 'storeCategory',
          entityId: `${context.category}/${data?.mainTag}/${data?.productId}`,
          summary: `업종 관리 - ${context.category}/${data?.mainTag}/${data?.productId} ${value ? '미노출' : '노출'} 처리 실패\nerror: ${description}`,
          level: 'error',
        });
        notification.error({
          message: `노출 여부 변경에 실패했습니다.`,
          description,
        });
      }
    },
    [context.category, data?.mainTag, data?.productId],
  );

  return <Switch loading={loading} checked={value} onChange={handleSwitchChange} />;
};
